import { atom } from 'jotai'
import { AccountDetails } from '../models/AccountDetails'

export const AccountDetailsAtom = atom(AccountDetails)
